
/**
 * 复制文本到剪贴板
 * 兼容 HTTP 环境（非安全上下文）
 * @param {string} text 要复制的文本
 * @returns {Promise<boolean>} 是否成功
 */
export async function copyToClipboard(text) {
    // 1. 优先尝试使用现代 API (Navigator Clipboard)
    // 注意：这个 API 通常只在 HTTPS 或 localhost 下可用
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            console.warn('navigator.clipboard failed, trying fallback', err);
        }
    }

    // 2. 回退方案：使用 document.execCommand('copy')
    // 创建一个临时的 textarea 元素
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // 确保元素不可见但可被选中
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        return successful; // true or false
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        document.body.removeChild(textArea);
        return false;
    }
}
